import type { State, Actions } from './types'

import { FETCHED } from './actionTypes'
import { FETCHED as FETCHED_MENUS } from 'store/menus/actionTypes'

const initialState = {}

export default function (
  state = initialState as State,
  action: Actions,
): State {
  switch (action.type) {
    case FETCHED_MENUS:
      return {
        ...state,
      }
    case FETCHED: {
      return {
        ...action.payload,
      }
    }
    default:
      return state
  }
}
